import {
  AnalyticsDigitalData,
  AnalyticsUserData,
  AnalyticsUserProfileData,
  AnalyticsWasteProfileAdminMetaData,
  AnalyticsWasteProfileAdminStatusChangeData,
  AnalyticsWasteProfileChangeData,
  AnalyticsWasteProfileData,
  AnalyticsWasteProfileRecertifyData,
  AnalyticsWasteServiceRequestData
} from '../interfaces';
import { AnalyticsUserDataModel } from './user-data.model';
import { AnalyticsUserProfileDataModel } from './user-profile-data.model';
import { AnalyticsWasteProfileAdminMetaDataModel } from './waste-profile-admin-metadata.model';
import { AnalyticsWasteProfileAdminStatusChangeDataModel } from './waste-profile-admin-status-change-data.model';
import { AnalyticsWasteProfileChangeDataModel } from './waste-profile-change-data.model';
import { AnalyticsWasteProfileDataModel } from './waste-profile-data.model';
import { AnalyticsWasteProfileRecertifyDataModel } from './waste-profile-recertify-data.model';
import { AnalyticsWasteServiceRequestDataModel } from './waste-service-request-data.model';

export class AnalyticsDigitalDataModel implements AnalyticsDigitalData {
  public static DEFAULT_CONFIG: AnalyticsDigitalData = {
    pageName: '',
    userData: AnalyticsUserDataModel.DEFAULT_CONFIG,
    wasteProfileData: AnalyticsWasteProfileDataModel.DEFAULT_CONFIG,
    wasteProfileRecertifyData:
      AnalyticsWasteProfileRecertifyDataModel.DEFAULT_CONFIG,
    wasteServiceRequestData:
      AnalyticsWasteServiceRequestDataModel.DEFAULT_CONFIG,
    wasteProfileChangeData: AnalyticsWasteProfileChangeDataModel.DEFAULT_CONFIG,
    userProfileData: AnalyticsUserProfileDataModel.DEFAULT_CONFIG,
    wasteProfileAdminMetaData:
      AnalyticsWasteProfileAdminMetaDataModel.DEFAULT_CONFIG,
    wasteProfileAdminStatusChangeData:
      AnalyticsWasteProfileAdminStatusChangeDataModel.DEFAULT_CONFIG
  };
  public pageName: string;
  public userData: AnalyticsUserData;
  public wasteProfileData: AnalyticsWasteProfileData;
  public wasteProfileRecertifyData: AnalyticsWasteProfileRecertifyData;
  public wasteServiceRequestData: AnalyticsWasteServiceRequestData;
  public wasteProfileChangeData: AnalyticsWasteProfileChangeData;
  public userProfileData: AnalyticsUserProfileData;
  public wasteProfileAdminMetaData: AnalyticsWasteProfileAdminMetaData;
  public wasteProfileAdminStatusChangeData: AnalyticsWasteProfileAdminStatusChangeData;
}
